import { FC } from 'react';
import { Tag } from 'antd';
import {
	RoleCardStyled,
	RoleFeatureStyled,
	RoleHeadingContainerStyled,
	RoleHeadingStyled,
	RolesFeaturesListStyled,
} from 'widgets/roles-info/ui/RoleCard/RoleCard.styles';

import { MpText } from 'shared/ui/MpText';

interface Props {
	heading: string;
	subheading: string;
	features: string[];
	inModal: boolean;
}

export const RoleCard: FC<Props> = ({ heading, subheading, features, inModal }) => (
	<RoleCardStyled>
		<RoleHeadingContainerStyled>
			<RoleHeadingStyled inModal={inModal}>{heading}</RoleHeadingStyled>
			<Tag color='blue' style={{ marginTop: `2px`, marginRight: `0` }}>
				{subheading}
			</Tag>
		</RoleHeadingContainerStyled>
		<RolesFeaturesListStyled>
			{features.map(n => (
				<RoleFeatureStyled key={n}>
					<MpText size={14}>{n}</MpText>
				</RoleFeatureStyled>
			))}
		</RolesFeaturesListStyled>
	</RoleCardStyled>
);
